import BaseClass from "../BaseClass.js";

export default class CreatorCamHandler extends BaseClass {

    constructor(element) {
        super(element);

        this.publishing = false;
        this.$camSelector = null;
        this.$audioSelector = null;
        this.$volumeMeter = null;
        this.$volumeBar = null;
        this.publisher = null;
        this.$startButton = null;
        this.$stopButton = null;
        this.$camOptions = null;
        this.$creatorStreamTimer = null;
        this.streamTimerInterval = null;
        this.$viewersAmountHolder = null;
        this.audioDevices = null;
        this.videoDevices = null;
        this.publisherEventListener = null;
        this.startStopListener = null;
        this.chatEventsListener = null;
        this.viewersAmountListener = null;
        this.host = null;
        this.roomName = null;
        this.chatServerURL = null;
        this.username = null;
        this.password = null;
        this.token = null;
        this.sdkURL = null;

        this.noMediaErrorTitle = "";
        this.noMediaErrorDescription = "";

        this.init();
        //  this.initUserMedia(true);
    }

    loadRed5SDK() {
        let mySelf = this;
        var red5ProSdkScript = document.createElement("script");
        red5ProSdkScript.src = this.sdkURL

        document.body.appendChild(red5ProSdkScript);

        $(red5ProSdkScript).on('load', function () {
            red5prosdk.setLogLevel('debug');
            console.error("red5pro sdk loaded");
            mySelf.preparePublishing();
        });
    }

    preparePublishing() {
        // this.createListener();
        this.createMainConfig();
        this.initUserMedia(true);

    }

    init() {
        let mySelf = this;

        if (this.$element.attr("data-room") != undefined) {
            this.roomName = this.$element.attr("data-room");
        }

        if (this.$element.attr("data-host") != undefined) {
            this.host = this.$element.attr("data-host");
        }

        if (this.$element.attr("data-username") != undefined) {
            this.username = this.$element.attr("data-username");
        }
        if (this.$element.attr("data-password") != undefined) {
            this.password = this.$element.attr("data-password");
        }
        if (this.$element.attr("data-token") != undefined) {
            this.token = this.$element.attr("data-token");
        }

        if (this.$element.attr("data-chat-host") != undefined) {
            this.chatServerURL = this.$element.attr("data-chat-host");
        }

        if (this.$element.attr("data-no-media-error-title") != undefined) {
            this.noMediaErrorTitle = this.$element.attr("data-no-media-error-title");
        }

        if (this.$element.attr("data-no-media-error-description") != undefined) {
            this.noMediaErrorDescription = this.$element.attr("data-no-media-error-description");
        }

        this.createListener();

        let $camSelector = this.$element.find('[data-type="cam_select"]');
        if ($camSelector != undefined) {
            this.$camSelector = $camSelector;
            this.$camSelector.on('change', function (event) {
                mySelf.selectVideoDevice(event.target.value, true);
            });
        }

        let $audioSelector = this.$element.find('[data-type="audio_select"]');
        if ($audioSelector != undefined) {
            this.$audioSelector = $audioSelector;
            this.$audioSelector.on('change', function (event) {
                mySelf.selectAudioDevice(event.target.value, true);
            });
        }

        let $volumeMeter = this.$element.find('[data-type="volume_meter"]');
        if ($volumeMeter != undefined) {
            this.$volumeMeter = $volumeMeter;
        }
        let $volumeBar = this.$element.find('[data-type="volume_bar"]');
        if ($volumeBar != undefined) {
            this.$volumeBar = $volumeBar;
        }

        let $startButton = this.$element.find('[data-type="start_publish_button"]');
        if ($startButton != undefined) {
            this.$startButton = $startButton;
            this.$startButton.on('click', this.startStopListener);
        }

        let $stopButton = this.$element.find('[data-type="stop_publish_button"]');
        if ($stopButton != undefined) {
            this.$stopButton = $stopButton;
            this.$stopButton.on('click', this.startStopListener);
        }

        let $camOptions = this.$element.find('[data-type="cam_options"]');
        if ($camOptions != undefined) {
            this.$camOptions = $camOptions;
        }

        if (this.$element.attr("data-sdk-url") != undefined) {
            this.sdkURL = this.$element.attr("data-sdk-url");
            this.loadRed5SDK();
        }

        let creatorStreamTimer = this.$element.find('[data-type="creator-stream-timer"]').first();

        if (creatorStreamTimer != undefined) {
            this.$creatorStreamTimer = creatorStreamTimer;
        }

        let viewersAmountHolder = this.$element.find('[data-type="viewers-amount"]').first();

        if (viewersAmountHolder != undefined) {
            this.$viewersAmountHolder = viewersAmountHolder;
        }

        $(document).on('viewers:amount:changed', this.viewersAmountListener);

        //mySelf.startCreatorChat();  // TODO Nur lokal aktivieren, damit der Chat ohne die CAMS getestet werden kann.
    }

    setViewersAmount(amount) {
        this.$viewersAmountHolder.text(amount);
    }

    createListener() {
        let mySelf = this;

        this.publisherEventListener = function (event, data) {

            if (event.type === 'Connect.Success' && publisher) {
                console.error("Connect.Success");
                mySelf.$startButton.addClass('hidden');
                mySelf.$stopButton.removeClass('hidden');
                mySelf.$camSelector.addClass('hidden');
                mySelf.$audioSelector.addClass('hidden');
                mySelf.$volumeMeter.addClass('hidden');
                mySelf.$volumeBar.addClass('hidden');
                mySelf.$camOptions.addClass('hidden');
            }
            if (event.type === 'Publish.Start') {
                mySelf.$startButton.addClass('hidden');
                mySelf.$stopButton.removeClass('hidden');
                mySelf.$camSelector.addClass('hidden');
                mySelf.$audioSelector.addClass('hidden');
                mySelf.$volumeMeter.addClass('hidden');
                mySelf.$volumeBar.addClass('hidden');
                mySelf.$camOptions.addClass('hidden');
                mySelf.startStreamTimer();
                mySelf.startCreatorChat();
            } else if (event.type === 'Unpublish.Success') {
                mySelf.$startButton.removeClass('hidden');
                mySelf.$stopButton.addClass('hidden');
                mySelf.publishing = false;
                mySelf.$camSelector.removeClass('hidden');
                mySelf.$audioSelector.removeClass('hidden');
                mySelf.$volumeMeter.removeClass('hidden');
                mySelf.$volumeBar.removeClass('hidden');
                mySelf.$camOptions.removeClass('hidden');
                mySelf.stopStreamTimer();
                mySelf.stopCreatorChat();
            } else if (event.type === 'Publisher.Connection.Closed') {
                mySelf.publishing = false;
                mySelf.$camSelector.removeClass('hidden');
                mySelf.$audioSelector.removeClass('hidden');
                mySelf.$volumeMeter.removeClass('hidden');
                mySelf.$volumeBar.removeClass('hidden');
                mySelf.$camOptions.removeClass('hidden');
                mySelf.stopStreamTimer();
                mySelf.stopCreatorChat();
                mySelf.unpublish().then(function () {
                }).catch(function (error) {
                });
            }
        }

        this.startStopListener = function (event) {
            // console.error(event);
            if (mySelf.publishing) {
                mySelf.stopPublish();
            } else {
                mySelf.startPublish();
            }
        }

        this.chatEventListener = function (event, data) {
            if (data.action != undefined) {
                switch (data.action) {
                    case "stopStream":
                        mySelf.stopPublish();
                        break;
                }

            }
        }

        $(document).on('stream:event', this.chatEventListener);

        this.viewersAmountListener = function (event, data) {
            if (data.viewersAmount != undefined) {
                mySelf.setViewersAmount(data.viewersAmount);
            }
        }
    }


    createMainConfig() {
        let mySelf = this;

        this.iceServers = [
            {
                urls: [
                    'stun:stun.l.google.com:19302',
                    'stun:stun1.l.google.com:19302',
                    'stun:stun2.l.google.com:19302',
                    'stun:stun3.l.google.com:19302',
                    'stun:stun4.l.google.com:19302',
                ],
            },
        ];

        this.desiredBandwidth = [];
        this.desiredBandwidth.audio = 56;
        this.desiredBandwidth.video = 3000;

        this.videoSettings = {
            width: {
                min: 0,
                max: 3840,
            },
            height: {
                min: 0,
                max: 2160,
            },
            frameRate: {
                min: 15,
                max: 15,
            },
        };

        this.mediaConstraints = {
            audio: true,
            video: true
        };

        this.baseConfiguration = {
            host: this.host,
            protocol: 'wss',
            port: '443',
            app: 'live',
            rtcConfiguration: {
                iceServers: this.iceServers,
                iceCandidatePoolSize: 2,
                bundlePolicy: 'max-bundle',
            },
            bandwidth: this.desiredBandwidth,
            mediaConstraints: this.mediaConstraints,
            signalingSocketOnly: true,
            enableChannelSignaling: true,
            trickleIce: true,
            connectionParams: {username: this.username, password: this.password, token: this.token},
            streamMode: 'live',
            streamName: this.roomName,
        }
    }


    initUserMedia(firstRun = false) {

        if (navigator.mediaDevices.getUserMedia) {

            let mySelf = this;

            this.unpublish().then(function () {

                let mediaPromise = navigator.mediaDevices.getUserMedia(mySelf.baseConfiguration.mediaConstraints);

                mediaPromise.then(function (mediastream) {

                    let devicesPromise = navigator.mediaDevices.enumerateDevices();

                    devicesPromise.then(function (devices) {

                        if (firstRun) {
                            mySelf.audioDevices = devices.filter(device => device.kind === 'audioinput');
                            mySelf.videoDevices = devices.filter(device => device.kind === 'videoinput');

                            mySelf.createVideoDeviceSelection();
                            mySelf.createAudioDeviceSelection();
                        }

                        mediastream.getVideoTracks().forEach(function (track) {
                            mySelf.selectVideoDevice(track.getSettings().deviceId);
                        });

                        mediastream.getAudioTracks().forEach(function (track) {
                            mySelf.selectAudioDevice(track.getSettings().deviceId);
                        })

                        mediastream.getTracks().forEach(function (track) {
                            track.stop()
                        });

                        mySelf.initPublisher();

                    }).catch(function (error) {
                        console.error(error);
                        mySelf.displayNoVideoError();
                    });
                })
                    .catch(function (error) {
                        console.error(error);
                        mySelf.displayNoVideoError();
                    });
            });
        }
    }

    displayNoVideoError() {

        this.$camOptions.addClass('hidden');
        this.$startButton.addClass('hidden');

        $(document).trigger("toast:show", {
            title: this.noMediaErrorTitle,
            subtitle: "",
            body: this.noMediaErrorDescription,
            type: "error",
            placement: "middle",
            autohide: false
        });

    }


    initPublisher(startPublish = false) {
        let mySelf = this;

        // this.baseConfiguration.streamName = this.roomName + '_' + this.generateRandomString(5);
        this.baseConfiguration.streamName = this.roomName;

        this.unpublish().then(function () {

            mySelf.publisher = new red5prosdk.WHIPClient();

            mySelf.publisher.init(mySelf.baseConfiguration)
                .then(function () {
                    if (startPublish) {
                        mySelf.publisher.publish().then(function () {
                                mySelf.publisher.on('*', mySelf.publisherEventListener);
                                mySelf.publishing = true;
                            }
                        ).catch(function (error) {
                            mySelf.publishing = false;
                        });
                    }
                    mySelf.visualizeSound();
                })
                .catch(function (error) {
                    mySelf.publisher.off('*', mySelf.publisherEventListener);
                    console.error(error);
                });

        }).catch(function (error) {
            console.error(error);
        });
    }


    startPublish() {
        console.error("startPublish");
        this.$startButton.addClass('hidden'); // Der Button soll sofort verschwinden, da der User sonst mehrfach klicken kann
        this.initPublisher(true);

    }

    stopPublish() {
        console.error("stopPublish");
        this.unpublish();
    }


    createVideoDeviceSelection() {
        let mySelf = this;
        if (this.videoDevices != null && this.$camSelector != null) {
            this.videoDevices.forEach(function (device) {
                mySelf.$camSelector.append('<option value="' + device.deviceId + '">' + device.label + '</option>');
            });
        }
    }

    createAudioDeviceSelection() {
        let mySelf = this;
        if (this.audioDevices != null && this.$audioSelector != null) {
            this.audioDevices.forEach(function (device) {
                mySelf.$audioSelector.append('<option value="' + device.deviceId + '">' + device.label + '</option>');
            });
        }
    }

    selectVideoDevice(deviceID, reInitMedia = false) {

        if (this.baseConfiguration.mediaConstraints.video.deviceId?.exact == deviceID) {
            // Keine Änderung für bereits ausgewähltes Gerät
            return;
        }

        this.baseConfiguration.mediaConstraints.video = {deviceId: {exact: deviceID}};
        //TODO Verbesserte Auswahl der Auflösung
        // this.baseConfiguration.mediaConstraints.video = Object.assign({}, this.videoSettings, {deviceId: {exact: deviceID}});


        let $selectedOption = this.$audioSelector.find('[value="' + deviceID + '"]').first();
        $selectedOption.prop("selected", true);

        if (reInitMedia) {
            this.initUserMedia();
        }
    }

    selectAudioDevice(deviceID, reInitMedia = false) {

        if (this.baseConfiguration.mediaConstraints.audio.deviceId?.exact == deviceID) {
            // Keine Änderung für bereits ausgewähltes Gerät
            return;
        }

        if (deviceID == "no_sound") {
            this.baseConfiguration.mediaConstraints.audio = false;
        } else {
            this.baseConfiguration.mediaConstraints.audio = {deviceId: {exact: deviceID}};
        }

        let $selectedOption = this.$audioSelector.find('[value="' + deviceID + '"]').first();
        $selectedOption.prop("selected", true);

        if (reInitMedia) {
            this.initUserMedia();
        }
    }

    visualizeSound() {

        if (this.baseConfiguration.mediaConstraints.audio == false) {
            return;
        }
        let mySelf = this;

        if (this.publisher.getMediaStream() == undefined) {
            // Muss leider so gelöst werden, da der MediaStream nicht sofort zur Verfügung steht und es keine Events, oder Callbacks gibt.
            window.setTimeout(function () {
                mySelf.visualizeSound();
            }, 200);
            return;

        }

        // AudioContext erstellen
        let audioContext = new (window.AudioContext || window.webkitAudioContext)();
        let analyser = audioContext.createAnalyser();
        analyser.fftSize = 256; // Kleinere FFT-Größe für Pegelanzeige

        // Datenarray für Lautstärke
        let dataArray = new Uint8Array(analyser.frequencyBinCount);

        // Mikrofon-Stream mit Analyser verbinden
        let microphone = audioContext.createMediaStreamSource(this.publisher.getMediaStream());
        microphone.connect(analyser);
        visualizeVolume();

        function visualizeVolume() {
            const update = () => {

                if (mySelf.$volumeBar == undefined || mySelf.$volumeBar == null) {
                    return;
                }
                // Hole Frequenzdaten
                analyser.getByteFrequencyData(dataArray);

                // Berechne den Durchschnitt der Amplitudendaten
                let sum = 0;
                for (const value of dataArray) {
                    sum += value;
                }
                const average = sum / dataArray.length;

                // Skaliere die Lautstärke auf den Prozentwert (0-100)
                const volume = Math.min(average / 2, 100); // Max. auf 100% begrenzen

                mySelf.$volumeBar.css('width', volume + '%');

                // Visualisierung fortsetzen
                requestAnimationFrame(update);
            };

            update();
        }
    }


    unpublish() {
        let mySelf = this;


        return new Promise(function (resolve, reject) {

            if (mySelf.publisher == undefined || mySelf.publisher == null) {
                resolve();
            }

            var stream = mySelf.publisher.getMediaStream();
            if (stream != undefined && stream != null) {
                stream.getTracks().forEach(function (track) {
                    track.stop()
                });
            }

            if (mySelf.publishing) {

                mySelf.publisher.unpublish().then(function () {
                    mySelf.publishing = false;
                    if (mySelf.publisher != undefined && mySelf.publisher != null) {
                        //TODO hier stimmt irgendwas mit der Reihenfolge der Anweisungen nicht und müsste genauer untersucht werden
                        mySelf.publisher.off('*', mySelf.publisherEventListener);
                    }
                    mySelf.tearDownPublisher();
                    resolve();
                })
                    .catch(function (error) {
                        mySelf.publishing = false;
                        console.error(error);
                        mySelf.tearDownPublisher();
                        reject(error);
                    })
            } else {
                mySelf.tearDownPublisher();
                resolve();
            }
        });
    }

    startCreatorChat() {
        $(document).trigger('creator:camchat:start', {authToken: this.token, roomName: this.roomName, serverURL: this.chatServerURL});
    }

    stopCreatorChat() {
        $(document).trigger('creator:camchat:stop', {roomName: this.roomName});
        this.setViewersAmount(0);
    }

    startStreamTimer() {
        let mySelf = this;

        if (mySelf.$creatorStreamTimer != null) {
            mySelf.streamStartTS = Math.floor(Date.now() / 1000);

            if (mySelf.streamTimerInterval) {
                clearInterval(mySelf.streamTimerInterval);
            }

            mySelf.$creatorStreamTimer.removeClass('hidden');

            mySelf.streamTimerInterval = setInterval(() => {
                const now = Math.floor(Date.now() / 1000);
                const elapsed = now - mySelf.streamStartTS;

                const hours = Math.floor(elapsed / 3600);
                const minutes = Math.floor((elapsed % 3600) / 60);
                const seconds = elapsed % 60;
                if (mySelf.$creatorStreamTimer != undefined) {
                    mySelf.$creatorStreamTimer.text(`${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`);
                }
                if (mySelf.streamEnded) {
                    clearInterval(mySelf.streamTimerInterval);
                }
            }, 1000);
        }
    }

    stopStreamTimer() {
        if (this.streamTimerInterval) {
            clearInterval(this.streamTimerInterval);
            this.streamTimerInterval = null;
        }
        this.$creatorStreamTimer.addClass('hidden');
    }

    tearDownPublisher() {
        if (this.publisher != null) {
// Testen ob das nicht doch benötigt wird.
            //    var stream = this.publisher.getMediaStream();
            // stream.getTracks().forEach(function (track) {
            //     track.stop()
            // });
            this.publisher.setView(undefined)
            this.publisher = null;
        }
    }

    destroyListener() {
        this.stopPublish();
        this.stopCreatorChat();
        this.$startButton.off('click', this.startStopListener);
        this.$stopButton.off('click', this.startStopListener);
        $(document).off('viewers:amount:changed', this.viewersAmountListener);
    }
}